export default "__VITE_ASSET__78558f78__"